import axios from 'axios';
import { getAccessToken } from './getAccessToken';

export const UseAxios = async (
  url: string,
  method: string,
  body?,
  eBillAPI: boolean = false,
  gw: boolean = true,
) => {
  const accessToken = await getAccessToken();
  const headers = {
    headers: {
      'x-token': accessToken,
    },
  };
  let urlBase = eBillAPI
    ? process.env.REACT_APP_EBILL_API_URL
    : process.env.REACT_APP_WEB_BI_API_URL;

  if(!eBillAPI && !gw){
    urlBase = process.env.REACT_APP_WEB_BI_LB_API_URL;
  }
  try {
    let result;
    if (method === 'get') {
      result = await axios[method](`${urlBase}${url}`, headers);
    } else {
      result = await axios[method](`${urlBase}${url}`, body, headers);
    }
    return { data: result.data };
  } catch (e) {
    return { error: e };
  }
};
